import { render, staticRenderFns } from "./giftmodify.vue?vue&type=template&id=32775d3e&scoped=true&"
import script from "./giftmodify.vue?vue&type=script&lang=js&"
export * from "./giftmodify.vue?vue&type=script&lang=js&"
import style0 from "./giftmodify.vue?vue&type=style&index=0&id=32775d3e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32775d3e",
  null
  
)

export default component.exports